import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {Home} from "./home.model";
import {HomeGenre} from "../genre/genre.model";

interface HomeState {
  state: any;
  data: Home | null;
  genres: HomeGenre[];
}

const initialState: HomeState = { state: null, data: null, genres: [] };

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setHome: (state, action: PayloadAction<Home>) => {
      state.data = action.payload;
    },
    setGenres: (state, action: PayloadAction<HomeGenre[]>) => {
      state.genres = action.payload;
    },
  },
});

export const {
  reducer: homeReducer,
  actions: homeActions,
} = homeSlice;
